import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../common/method/handleNotificationAlert'

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
    clubmemberSelect: "clubmemberSelect [Action]",
    clubmemberSelectLoading: "clubmemberSelectLoading [Action]",
    clubmemberSelectAsync: "clubmemberSelectAsync [Action]",
};
const inistiaState = {
    data: {},
    loading: false
};

export const clubmember_Select = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.clubmemberSelect:
            return {
                ...state,
                data: payload,
            };
        case actionTypes.clubmemberSelectLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {
    yield put({ type: actionTypes.clubmemberSelectLoading, payload: true })



    let config = {
        url: "select_request"
    };

    let data = {
        table: "clubmember",
        method_type: "select",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }
        yield put({ type: actionTypes.clubmemberSelect, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.clubmemberSelectLoading, payload: false })

    }
}

export function* selectClubmember() {
    yield takeLatest(actionTypes.clubmemberSelectAsync, handleWorker);
}
